import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import { CLI_CINEMA_CLIENT_ID, FEATURES, HIGHLIGHT_DEFAULT, PROGRAM_CINEMAS, PROGRAM_CLI_MOVIES_ITEMS } from '../../../constants/state'
import getData from '../../../functions/getData'
import EditHighlight from '../../PageEditItem/present/EditHighlight'
import getMovieSortedByTitle from '../../../functions/getMoviesSortedByTitle'
import { highlightsAddItem } from '../../../actions'

const mapStateToProps = state => ({
    itemData: HIGHLIGHT_DEFAULT,
    movieData: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    features: getData(state, FEATURES),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: itemData => {
        dispatch(highlightsAddItem(itemData, ownProps.closePagePath))
    }
})

const AddHighlightContainer = ({itemData, onUpdateItem, movieData, cliCinemas, closePagePath, clientCinemaId, suffixEdit, features}) => <EditHighlight
    itemData={itemData}
    onUpdateItem={onUpdateItem}
    movieData={movieData}
    suffixEdit={suffixEdit}
    cliCinemas={cliCinemas}
    closePagePath={closePagePath}
    clientCinemaId={clientCinemaId}
    features={features}
    sortedMovieDataKeys={getMovieSortedByTitle(movieData)}
/>

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(AddHighlightContainer)